module.exports = __webpack_public_path__ + "images/footerphoneimage-2711ab745c4b946ba260ea11b7ccf816.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/footerphoneimage.png
// module id = ./client/assets/images/footerphoneimage.png
// module chunks = 1 6 7 8 9